<template>
  <div class="columns event-container is-vcentered">
    <span class="column is-2">
      <font-awesome-icon :class="iconStatus" :icon="listIcon" />
    </span>
    <div class="column has-text-left is-10">
      <div class="columns is-vcentered">
        <div class="column">
          <h3>{{event.title}}{{ event.name ? ` with ${event.name}` : ''}}</h3>
        </div>
        <div class="column">
          <p>{{ eventContent }}</p>
        </div>
        <div v-if="hasBriefs" class="column is-4">
          <a
            v-if="event.type=='project'"
            @click.prevent="gotoProject($store.state.auth.user.groups[0].id, $store.state.auth.user.id, event.project)"
          >Brief</a>
          <a v-if="event.type=='todo'" @click="$emit('todoBriefClicked', event)">Brief</a>
          <router-link v-if="event.type=='booking'" to="/mentor">Mentor</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseHelper from "@/helpers/BaseHelper";

export default {
  name: "ListItem",
  props: {
    event: Object,
    hasBriefs: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mixins: [BaseHelper],

  data() {
    return {
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    };
  },
  computed: {
    iconStatus() {
      let status = null;
      switch (this.event.class) {
        case "submitted":
          status = "submittedIcon";
          break;
        case "outstanding":
          status = "outstandingIcon";
          break;
        case "overdue":
          status = "overdueIcon";
          break;
        case "upcoming":
          status = "upcomingIcon";
          break;
        case "passed":
          status = "passedIcon";
          break;
      }
      return status;
    },
    listIcon() {
      let listIcon = "";
      if (this.event.type == "project") {
        listIcon = "book-open";
      } else if (this.event.type == "booking") {
        listIcon = "clock";
      } else if (this.event.type == "todo") {
        listIcon = "clipboard-check";
      }
      return listIcon;
    },
    eventContent() {
      let content = "";
      if (this.event.type == "project") {
        content =
          "Due on " +
          this.endDate.getDate() +
          " " +
          this.months[this.endDate.getMonth()] +
          ".";
      } else if (this.event.type == "booking") {
        content =
          "This meeting will happen on " +
          this.endDate.getDate() +
          " " +
          this.months[this.endDate.getMonth()] +
          " at " +
          this.$moment(this.endDate).format("h:mm a") +
          ".";
      } else if (this.event.type == "todo") {
        content =
          "Due on " +
          this.endDate.getDate() +
          " " +
          this.months[this.endDate.getMonth()] +
          ".";
      }
      return content;
    },
    endDate() {
      let date = new Date(this.event.end);
      return date;
    }
  }
};
</script>

 <style lang="scss">
@import "@/assets/scss/variables.scss";

.event-container {
  border-top: 1px solid $pantoneBlue;
}

.submittedIcon {
  color: green;
}
.overdueIcon {
  color: red;
}
.outstandingIcon {
  color: purple;
}
.passedIcon {
  color: $pantoneBlue;
}
.upcomingIcon {
  color: $orange;
}
</style>


